<script>
//--------------------------------------------------
// imported classes
//--------------------------------------------------
import { Row, Col, Icon, Toast, Popover } from 'vant'

//--------------------------------------------------
// global registration
//--------------------------------------------------

//--------------------------------------------------
// main script
//--------------------------------------------------
export default {
    //--------------------------------------------------
	// component extends
	//--------------------------------------------------

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-row': Row,
        'van-col': Col,
        'van-icon': Icon,
        'van-popover': Popover,
    },

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
	data() {
        return {
            role: 'skater',
            group: {
                stats: [],
                rankings: [],
            },
            isLoading: true,
            locale: {},
            // save the popover vars, and init via the controller dynamically
            popovers: [],
        }
	},

    //--------------------------------------------------
    // component life cycle trigger
    //--------------------------------------------------

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        groupStats() {
            // console.log('@groupStats', this.group.stats, this.group.rankings)
            for (let i = 0; i < this.group.stats.length; i++) {
                let item = this.group.stats[i]
                for (let j = 0; j < this.group.rankings.length; j++) {
                    let ranking = this.group.rankings[j]
                    if (item.groupId == ranking.groupId && item[ranking.indicator]) {
                        item[ranking.indicator + '-rank'] = ranking.rank ? this.locale.localeProp('level-rank', {rank: ranking.rank}) : ''
                    }
                }
            }
            return this.group.stats
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        //--------------------------------------------------
        // handler method
        //--------------------------------------------------
        showToast(text) {
            Toast(text)
        },
        onServiceBtnClick() {
            // console.log('onServiceBtnClick')
            this.$emit('custom-event', {
                type: 'popup-service'
            })
        },
        onGroupBtnClick(groupId) {
            // console.log('onGroupBtnClick', groupId)
            this.$emit('custom-event', {
                type: 'go-detail',
                data: {
                    type: 'group',
                    groupId: groupId
                }
            })
        },

        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        getActions(text) {
            return [
                { text: this.locale[text] }
            ]
        },
    }
}
</script>

<template>
    <!-- component -->
    <div class="report-stats">
        <div v-if="group.stats.length > 0 || isLoading">
            <div class="container">
                <div v-for="(item, index) in groupStats" :key="index" class="text-center b-wide-margin">
                    <van-row class="main-color normal-text h-inner-padding bg-minor">
                        <van-col span="4" class="van-ellipsis"><span>{{ item.season }}</span></van-col>
                        <van-col span="5" class="van-ellipsis"><span>{{ item.league }}</span></van-col>
                        <van-col span="6" class="van-ellipsis"><span>{{ item.group }}</span></van-col>
                        <van-col span="6" class="van-ellipsis"><span>{{ item.team }}</span></van-col>
                        <van-col span="3" class="van-ellipsis"><span>{{ item.position }}</span></van-col>
                    </van-row>
                    <table v-if="role == 'skater'" class="table text-center">
                        <thead v-if="popovers.length > index" class="minor-color minor-text">
                            <tr>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['gp']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[-6, 8]"
                                        placement="top-start"
                                        :actions="getActions('games-played')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['games-played-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['g']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[-10, 8]"
                                        placement="top-start"
                                        :actions="getActions('goals')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['goals-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['a']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[-10, 8]"
                                        placement="top-start"
                                        :actions="getActions('assists')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['assists-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['p']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[-10, 8]"
                                        placement="top-start"
                                        :actions="getActions('points')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['points-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['pim']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[-2, 8]"
                                        placement="top-start"
                                        :actions="getActions('penalty-mins')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['penalty-mins-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['ppg']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[-2, 8]"
                                        placement="top-start"
                                        :actions="getActions('power-play-goals')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['power-play-goals-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['shg']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[-2, 8]"
                                        placement="top-start"
                                        :actions="getActions('short-handed-goals')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['short-handed-goals-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['psg']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[-2, 8]"
                                        placement="top-start"
                                        :actions="getActions('penalty-shot-goals')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['penalty-shot-goals-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['otg']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[-2, 8]"
                                        placement="top-start"
                                        :actions="getActions('overtime-goals')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['overtime-goals-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['gwg']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[-2, 8]"
                                        placement="top-start"
                                        :actions="getActions('game-winning-goals')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['game-winning-goals-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['sogp']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[10, 8]"
                                        placement="top-end"
                                        :actions="getActions('shootout-games-played')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['shootout-games-played-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['sog']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[10, 8]"
                                        placement="top-end"
                                        :actions="getActions('shootout-goals')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['shootout-goals-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['sos']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[10, 8]"
                                        placement="top-end"
                                        :actions="getActions('shootout-shots')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['shootout-shots-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['sosp']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[10, 8]"
                                        placement="top-end"
                                        :actions="getActions('shootout-shooting-percentage')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['shootout-shooting-percentage-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>{{ locale['detail'] }}</th>
                            </tr>
                        </thead>
                        <thead v-else class="minor-color minor-text">
                            <tr>
                                <th>{{ locale['games-played-i'] }}</th>
                                <th>{{ locale['goals-i'] }}</th>
                                <th>{{ locale['assists-i'] }}</th>
                                <th>{{ locale['points-i'] }}</th>
                                <th>{{ locale['penalty-mins-i'] }}</th>
                                <th>{{ locale['power-play-goals-i'] }}</th>
                                <th>{{ locale['short-handed-goals-i'] }}</th>
                                <th>{{ locale['penalty-shot-goals-i'] }}</th>
                                <th>{{ locale['overtime-goals-i'] }}</th>
                                <th>{{ locale['game-winning-goals-i'] }}</th>
                                <th>{{ locale['shootout-games-played-i'] }}</th>
                                <th>{{ locale['shootout-goals-i'] }}</th>
                                <th>{{ locale['shootout-shots-i'] }}</th>
                                <th>{{ locale['shootout-shooting-percentage-i'] }}</th>
                                <th>{{ locale['detail'] }}</th>
                            </tr>
                        </thead> 
                        <tbody class="main-secondary-color minor-text">
                            <tr>
                                <td>{{ item.cgp }}</td>
                                <td>{{ item.g }}</td>
                                <td>{{ item.a }}</td>
                                <td>{{ item.p }}</td>
                                <td>{{ item.pim }}</td>
                                <td>{{ item.ppg }}</td>
                                <td>{{ item.shg }}</td>
                                <td>{{ item.psg }}</td>
                                <td>{{ item.otg }}</td>
                                <td>{{ item.gwg }}</td>
                                <td>{{ item.sogp }}</td>
                                <td>{{ item.sog }}</td>
                                <td>{{ item.sos }}</td>
                                <td>{{ item.sosp }}</td>
                                <td><van-icon name="more-o" @click="onGroupBtnClick(item.groupId)"/></td>
                            </tr>
                            <tr>
                                <td>{{ item['cgp-rank'] }}</td>
                                <td>{{ item['g-rank'] }}</td>
                                <td>{{ item['a-rank'] }}</td>
                                <td>{{ item['p-rank'] }}</td>
                                <td>{{ item['pim-rank'] }}</td>
                                <td>{{ item['ppg-rank'] }}</td>
                                <td>{{ item['shg-rank'] }}</td>
                                <td>{{ item['psg-rank'] }}</td>
                                <td>{{ item['otg-rank'] }}</td>
                                <td>{{ item['gwg-rank'] }}</td>        
                                <td>{{ item['sogp-rank'] }}</td>
                                <td>{{ item['sog-rank'] }}</td>
                                <td>{{ item['sos-rank'] }}</td>
                                <td>{{ item['sosp-rank'] }}</td>
                                <td><van-icon name="more-o" @click="onGroupBtnClick(item.groupId)"/></td>
                            </tr>
                        </tbody>
                    </table>
                    <table v-else class="table text-center">
                    <thead v-if="popovers.length > index" class="minor-color minor-text">
                            <tr>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['gp']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[-6, 8]"
                                        placement="top-start"
                                        :actions="getActions('games-played')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['games-played-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['w']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[-10, 8]"
                                        placement="top-start"
                                        :actions="getActions('wins')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['wins-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['l']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[-10, 8]"
                                        placement="top-start"
                                        :actions="getActions('losses')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['losses-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['wp']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[-10, 8]"
                                        placement="top-start"
                                        :actions="getActions('wins-percentage')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['wins-percentage-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['so']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[-2, 8]"
                                        placement="top-start"
                                        :actions="getActions('shutouts')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['shutouts-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['ga']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[-2, 8]"
                                        placement="top-start"
                                        :actions="getActions('goals-against')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['goals-against-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['gaa']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[-2, 8]"
                                        placement="top-start"
                                        :actions="getActions('goals-against-average')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['goals-against-average-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['ppga']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[-2, 8]"
                                        placement="top-start"
                                        :actions="getActions('power-play-goals-against')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['power-play-goals-against-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['shga']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[-2, 8]"
                                        placement="top-start"
                                        :actions="getActions('short-handed-goals-against')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['short-handed-goals-against-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['psga']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[-2, 8]"
                                        placement="top-start"
                                        :actions="getActions('penalty-shot-goals-against')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['penalty-shot-goals-against-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['otga']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[10, 8]"
                                        placement="top-end"
                                        :actions="getActions('overtime-goals-against')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['overtime-goals-against-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['gwga']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[10, 8]"
                                        placement="top-end"
                                        :actions="getActions('game-winning-goals-against')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['game-winning-goals-against-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['sogp']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[10, 8]"
                                        placement="top-end"
                                        :actions="getActions('shootout-games-played')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['shootout-games-played-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['sow']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[10, 8]"
                                        placement="top-end"
                                        :actions="getActions('shootout-wins')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['shootout-wins-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['sol']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[10, 8]"
                                        placement="top-end"
                                        :actions="getActions('shootout-losses')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['shootout-losses-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['sosa']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[10, 8]"
                                        placement="top-end"
                                        :actions="getActions('shootout-shots-against')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['shootout-shots-against-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['soga']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[10, 8]"
                                        placement="top-end"
                                        :actions="getActions('shootout-goals-against')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['shootout-goals-against-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['sosv']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[10, 8]"
                                        placement="top-end"
                                        :actions="getActions('shootout-saves')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['shootout-saves-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>
                                    <van-popover
                                        v-model="popovers[index]['sosvp']"
                                        trigger="click"
                                        theme="dark"
                                        :offset="[0, 8]"
                                        placement="top-end"
                                        :actions="getActions('shootout-saves-percentage')"
                                    >
                                        <template #reference>
                                            <span>{{ locale['shootout-saves-percentage-i'] }}</span>
                                        </template>
                                    </van-popover>
                                </th>
                                <th>{{ locale['detail'] }}</th>
                            </tr>
                        </thead>
                        <thead v-else class="minor-color minor-text">
                            <tr>
                                <th>{{ locale['games-played-i'] }}</th>
                                <th>{{ locale['wins-i'] }}</th>
                                <th>{{ locale['losses-i'] }}</th>
                                <th>{{ locale['wins-percentage-i'] }}</th>
                                <th>{{ locale['shutouts-i'] }}</th>
                                <th>{{ locale['goals-against-i'] }}</th>
                                <th>{{ locale['goals-against-average-i'] }}</th>
                                <th>{{ locale['power-play-goals-against-i'] }}</th>
                                <th>{{ locale['short-handed-goals-against-i'] }}</th>
                                <th>{{ locale['penalty-shot-goals-against-i'] }}</th>
                                <th>{{ locale['overtime-goals-against-i'] }}</th>
                                <th>{{ locale['game-winning-goals-against-i'] }}</th>
                                <th>{{ locale['shootout-games-played-i'] }}</th>
                                <th>{{ locale['shootout-wins-i'] }}</th>
                                <th>{{ locale['shootout-losses-i'] }}</th>
                                <th>{{ locale['shootout-shots-against-i'] }}</th>
                                <th>{{ locale['shootout-goals-against-i'] }}</th>
                                <th>{{ locale['shootout-saves-i'] }}</th>
                                <th>{{ locale['shootout-saves-percentage-i'] }}</th>
                                <th>{{ locale['detail'] }}</th>
                            </tr>
                        </thead> 
                        <tbody class="main-secondary-color minor-text">
                            <tr>
                                <td>{{ item.cgp }}</td>
                                <td>{{ item.w }}</td>
                                <td>{{ item.l }}</td>
                                <td>{{ item.wp }}</td>
                                <td>{{ item.so }}</td>
                                <td>{{ item.ga }}</td>
                                <td>{{ item.gaa }}</td>
                                <td>{{ item.ppga }}</td>
                                <td>{{ item.shga }}</td>
                                <td>{{ item.psga }}</td>
                                <td>{{ item.otga }}</td>
                                <td>{{ item.gwga }}</td>
                                <td>{{ item.sogp }}</td>
                                <td>{{ item.sow }}</td>
                                <td>{{ item.sol }}</td>
                                <td>{{ item.sosa }}</td>
                                <td>{{ item.soga }}</td>
                                <td>{{ item.sosv }}</td>
                                <td>{{ item.sosvp }}</td>
                                <td><van-icon name="more-o" @click="onGroupBtnClick(item.groupId)"/></td>
                            </tr>
                            <tr>
                                <td>{{ item['cgp-rank'] }}</td>     
                                <td>{{ item['w-rank'] }}</td>
                                <td>{{ item['l-rank'] }}</td>
                                <td>{{ item['wp-rank'] }}</td>
                                <td>{{ item['so-rank'] }}</td>
                                <td>{{ item['ga-rank'] }}</td>
                                <td>{{ item['gaa-rank'] }}</td>
                                <td>{{ item['ppga-rank'] }}</td>
                                <td>{{ item['shga-rank'] }}</td>
                                <td>{{ item['psga-rank'] }}</td>
                                <td>{{ item['otga-rank'] }}</td>
                                <td>{{ item['gwga-rank'] }}</td>
                                <td>{{ item['sogp-rank'] }}</td>
                                <td>{{ item['sow-rank'] }}</td>
                                <td>{{ item['sol-rank'] }}</td>
                                <td>{{ item['sosa-rank'] }}</td>
                                <td>{{ item['soga-rank'] }}</td>
                                <td>{{ item['sosv-rank'] }}</td>
                                <td>{{ item['sosvp-rank'] }}</td>
                                <td><van-icon name="more-o" @click="onGroupBtnClick(item.groupId)"/></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="service-unit justify-center">
                <div class="wm-wrapper">
                    <img src="@/fcl/assets/user/player-stats-group-wm.png" style="width: 345px; height: 131px;"/>
                </div>
                <div class="float-layer absolute">
                    <div class="lock-wrapper text-center">
                        <img src="@/fcl/assets/user/lock-symbol.png" style="width: 39px; height: 39px;" />
                    </div>
                    <div class="prompt-hint text-center">
                        <span class="block text-title">{{ locale['launch-service'] }}</span>
                        <span class="block normal-text">{{ locale['player-stats-group-feature'] }}</span>
                    </div>
                </div>
            </div>
            <div class="t-wide-margin l-wide-margin">
                <div class="service-button btn justify-center vertical-center" @click="onServiceBtnClick">
                    <span class="color-white text-title">{{ locale['data-service-launch'] }}</span>
                    <span class="l-outer-margin"><img src="@/fcl/assets/user/vip-symbol.png" style="height: 12px; width: 16px;"/></span>
                </div>
            </div>
        </div>
        <van-overlay 
            :show="isLoading" 
            class="vertical-center justify-center"
        >
            <van-loading />
        </van-overlay>
    </div>
</template>

<style scoped>
.service-unit {
    height: 180px;
}
.service-button {
    height: 45px;
    width: 346px;
    background: #E1671C;
}
.float-layer {
    margin-top: 86px;
}
table {
    width: 100%;
    overflow: auto;
    display: block;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .1);
}
th, td {
    white-space: nowrap;
    padding: 4px;
    background-color: #F9F9F9;
}
</style>